import { MarkingPeriodEnum } from '../../../../../schemaTypes'

export type BehaviorHomeProps = {
  studentId: string
  selectedMarkingPeriod: MarkingPeriodEnum
}

export const BehaviorHome = ({}: BehaviorHomeProps) => {
  return (
    <>
      <div></div>
    </>
  )
}
